(() => {
  const ROOT = "[data-embe-videos]";
  const SWIPER_SEL = "[data-embe-videos-swiper]";
  const ADD_TO_CART_SEL = "[data-embe-videos-add-to-cart]";

  function startCartButtonLoading(btn) {
    if (!btn || btn.classList.contains("loading")) return;
    btn.setAttribute("aria-disabled", "true");
    btn.setAttribute("aria-busy", "true");
    btn.classList.add("loading");
    const sp = btn.querySelector(".loading__spinner");
    if (sp) sp.classList.remove("hidden");
  }

  function stopCartButtonLoading(btn) {
    if (!btn) return;
    btn.removeAttribute("aria-disabled");
    btn.removeAttribute("aria-busy");
    btn.classList.remove("loading");
    const sp = btn.querySelector(".loading__spinner");
    if (sp) sp.classList.add("hidden");
  }

  async function addVariantToCart(variantId) {
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    const cartAddUrl = window.routes?.cart_add_url || "/cart/add";

    const config = typeof fetchConfig === "function" ? fetchConfig("javascript") : { method: "POST", headers: {} };
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");

    if (cart?.getSectionsToRender) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id),
      );
      formData.append("sections_url", window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    const res = await fetch(cartAddUrl, config);
    const text = await res.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      console.error(
        "[embe-skin-videos] Cart add returned non-JSON (status %s). First bytes: %s",
        res.status,
        text.slice(0, 200),
      );
      throw new Error("Cart add failed");
    }

    if (data?.status) throw new Error(data?.description || data?.message || "Cart error");

    if (!cart?.renderContents) {
      window.location = window.routes?.cart_url || "/cart";
      return;
    }

    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "embe-skin-videos",
        productVariantId: String(variantId),
        cartData: data,
      });
    }

    cart.renderContents(data);
  }

  function onAddToCartClick(e) {
    const btn = e.target.closest(ADD_TO_CART_SEL);
    if (!btn || !btn.closest(ROOT)) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled || btn.classList.contains("loading")) return;

    const productUrl = btn.getAttribute("data-product-url");
    const variantId = btn.getAttribute("data-variant-id");
    const needsOptions = btn.getAttribute("data-needs-options") === "true";

    if (needsOptions || !variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    startCartButtonLoading(btn);
    addVariantToCart(variantId)
      .catch((err) => console.error(err))
      .finally(() => {
        stopCartButtonLoading(btn);
      });
  }

  function pauseSlide(slide) {
    const v = slide.querySelector("video.embe-videos__native");
    if (v) v.pause();
  }

  function playSlide(slide) {
    if ((slide.dataset.embeVideoType || "none") === "none") return;
    const v = slide.querySelector("video.embe-videos__native");

    if (!v) return;

    // Important for iOS Safari
    v.muted = isSlideMuted(slide);

    const playPromise = v.play();

    if (playPromise?.catch) {
      playPromise.catch(() => {});
    }
  }

  function setSlideMuted(slide, muted) {
    slide.dataset.embeMuted = muted ? "true" : "false";
    const v = slide.querySelector("video.embe-videos__native");
    if (v) v.muted = muted;
  }

  function isSlideMuted(slide) {
    const v = slide.querySelector("video.embe-videos__native");
    if (v) return !!v.muted;
    return slide.dataset.embeMuted !== "false";
  }

  function syncMuteButton(slide) {
    const btn = slide.querySelector("[data-embe-videos-mute]");
    if (!btn) return;
    const muted = isSlideMuted(slide);
    btn.setAttribute("aria-pressed", muted ? "true" : "false");
    btn.setAttribute("aria-label", muted ? "Unmute video" : "Mute video");
    const iconMuted =
      btn.querySelector('[data-embe-mute-icon="muted"]') ||
      btn.querySelector(".embe-videos__mute-text--muted") ||
      btn.querySelector(".embe-videos__mute-icon--muted");
    const iconUn =
      btn.querySelector('[data-embe-mute-icon="unmuted"]') ||
      btn.querySelector(".embe-videos__mute-text--unmuted") ||
      btn.querySelector(".embe-videos__mute-icon--unmuted");
    const svgs = Array.from(btn.querySelectorAll("svg"));
    const fallbackMuted = svgs[0] || null;
    const fallbackUn = svgs[1] || null;
    const showMuted = iconMuted || fallbackMuted;
    const showUn = iconUn || fallbackUn;
    if (showMuted) showMuted.toggleAttribute("hidden", !muted);
    if (showUn) showUn.toggleAttribute("hidden", muted);
  }

  function stopAll(slides) {
    slides.forEach((s) => pauseSlide(s));
  }

  function initSection(section) {
    const swiperEl = section.querySelector(SWIPER_SEL);
    if (!swiperEl) return;

    const slides = Array.from(section.querySelectorAll("[data-embe-video-slide]"));
    slides.forEach((slide) => {
      if (!slide.dataset.embeMuted) slide.dataset.embeMuted = "true";
    });

    if (!window.Swiper) {
      if (section.dataset.embeVideosPending === "1") return;
      section.dataset.embeVideosPending = "1";
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (window.Swiper) {
          clearInterval(timer);
          delete section.dataset.embeVideosPending;
          requestAnimationFrame(() => initSection(section));
          return;
        }
        if (tries >= 40) {
          clearInterval(timer);
          delete section.dataset.embeVideosPending;
        }
      }, 100);
      return;
    }

    if (section.dataset.embeVideosInit === "1") return;
    section.dataset.embeVideosInit = "1";

    const prev = swiperEl.querySelector(".swiper-button-prev");
    const next = swiperEl.querySelector(".swiper-button-next");
    const pagination = swiperEl.querySelector(".swiper-pagination");

    const opts = {
      slidesPerView: 1.2,
      spaceBetween: 10,
      speed: 500,
      roundLengths: true,
      watchOverflow: true,
      //observer: true,
      observeParents: true,
      breakpoints: {
        640: { slidesPerView: 2 },
        990: { slidesPerView: 3, spaceBetween: 16 },
        1080: { slidesPerView: 4, spaceBetween: 24 },
        1600: { slidesPerView: 5, spaceBetween: 26 },
      },
    };
    if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
    if (pagination) opts.pagination = { el: pagination, clickable: true };

    let sw;
    try {
      sw = new window.Swiper(swiperEl, opts);
    } catch (e) {
      console.error(e);
      return;
    }

    // Save instance for cleanup
    section._embeSwiper = sw;

    const activate = (slide) => {
      if (!slide) return;
      stopAll(slides);
      playSlide(slide);
      slides.forEach(syncMuteButton);
    };

    slides.forEach((slide) => {
      // Play this slide's video on hover over the video area only (does not change Swiper index).
      const media = slide.querySelector(".embe-videos__media");

      const activateHandler = () => {
        activate(slide);
      };

      // Desktop hover
      media?.addEventListener("pointerenter", activateHandler, {
        passive: true,
      });

      // Mobile tap
      media?.addEventListener("click", activateHandler, {
        passive: true,
      });

      const muteBtn = slide.querySelector("[data-embe-videos-mute]");
      muteBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        const muted = isSlideMuted(slide);
        setSlideMuted(slide, !muted);
        syncMuteButton(slide);
      });
    });

    // Faster UX on mobile
    sw.on("slideChange", () => {
      const slide = slides[sw.activeIndex];
      if (slide) activate(slide);
    });

    requestAnimationFrame(() => {
      if (slides[0]) activate(slides[0]);
    });

    // Pause videos when tab inactive
    const visibilityHandler = () => {
      if (document.hidden) {
        stopAll(slides);
      }
    };

    document.addEventListener("visibilitychange", visibilityHandler);

    section._embeVisibilityHandler = visibilityHandler;
  }

  function destroySection(section) {
    if (!section) return;

    if (section._embeSwiper) {
      section._embeSwiper.destroy(true, true);
      section._embeSwiper = null;
    }

    if (section._embeVisibilityHandler) {
      document.removeEventListener("visibilitychange", section._embeVisibilityHandler);

      section._embeVisibilityHandler = null;
    }

    delete section.dataset.embeVideosInit;
  }

  function init(root = document) {
    let sections;
    if (root.matches?.(ROOT)) {
      sections = [root];
    } else {
      const found = root.querySelectorAll?.(ROOT);
      sections = found && found.length ? found : document.querySelectorAll(ROOT);
    }
    sections.forEach((s) => initSection(s));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (e) => {
    init(e.target);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    destroySection(e.target);
  });

  document.addEventListener("click", onAddToCartClick);
})();
